import {
  create_bool,
  create_continuous_colors,
  create_continuous_number,
  create_discrete_colors,
  create_discrete_number,
  create_single_color_picker,
  create_enum,
  create_range_number
} from '@/components/settings/creators'

import {
  black, candela_cat_10, transparent, white
} from '@/utils/colors/'

const area_chart_base = () => {
  return {
    plot_colors: create_discrete_colors({
      key: 'colors',
      label: 'Line Colors',
      value: 0
    }),
    show_legend: create_bool({
      key: 'show_legend',
      label: 'Show Legend',
      value: true
    }),
    show_grid: create_bool({
      key: 'show_grid',
      label: 'Show Grid',
      value: true
    })
  }
}

const line_chart_base = () => {
  return {
    plot_colors: create_discrete_colors({
      key: 'colors',
      label: 'Line Colors',
      value: 0
    }),
    show_legend: create_bool({
      key: 'show_legend',
      label: 'Show Legend',
      value: true
    }),
    show_grid: create_bool({
      key: 'show_grid',
      label: 'Show Grid',
      value: true
    })
  }
}

export default {
  'annotated-doc'() {
    return {
      annotation_colors: create_discrete_colors({
        key: 'annotation_colors',
        label: 'Annotation Colors',
        value: 0
      })
    }
  },
  'area-chart'() {
    return area_chart_base()
  },
  'area-chart-spline'() {
    return area_chart_base()
  },
  'area-chart-stepped'() {
    return area_chart_base()
  },
  'bar-chart'() {
    return {
      plot_colors: create_single_color_picker({
        key: 'bar_color',
        label: 'Bar Color',
        value: 0
      }),
      show_grid: create_bool({
        key: 'show_grid',
        label: 'Show Grid',
        value: true
      })
    }
  },
  'cell-grid'() {
    return {
      colors: create_continuous_colors({
        label: 'Color Spectrum'
      })
    }
  },
  'donut-chart'() {
    return {
      colors: create_discrete_colors({
        label: 'Color Palette'
      }),
      inner_radius: create_continuous_number({
        label: 'Inner Radius %',
        min: 0.05,
        max: 1,
        value: 0.25
      })
    }
  },
  'gradient-legend'() {
    return {
      spectrum: create_continuous_colors({
        key: 'colors',
        label: 'Color Spectrum',
        value: 6
      })
    }
  },
  'grouped-bar-chart'() {
    return {
      colors: create_continuous_colors({
        key: 'colors',
        label: 'Color',
        value: 11
      }),
      show_grid: create_bool({
        key: 'show_grid',
        label: 'Show Grid',
        value: true
      }),
      show_legend: create_bool({
        key: 'show_legend',
        label: 'Show Legend',
        value: true
      })
    }
  },
  'heatmap'() {
    return {
      spectrum: create_continuous_colors({
        key: 'colors',
        label: 'Color Spectrum',
        value: 6
      })
    }
  },
  'histogram'() {
    return {
      plot_colors: create_discrete_colors({
        key: 'colors',
        label: 'Line Colors',
        value: 0
      }),
      show_grid: create_bool({
        key: 'show_grid',
        label: 'Show Grid',
        value: true
      }),
      show_legend: create_bool({
        key: 'show_legend',
        label: 'Show Legend',
        value: true
      })
    }
  },
  'line-chart'() {
    return line_chart_base()
  },
  'line-chart-spline'() {
    return line_chart_base()
  },
  'line-chart-stepped'() {
    return line_chart_base()
  },
  'scatter-plot'() {
    return {
      plot_colors: create_discrete_colors({
        key: 'colors',
        label: 'Point Colors',
        value: 0
      }),
      point_radius: create_continuous_number({
        key: 'point_radius',
        label: 'Point Radius',
        min: 2,
        max: 8,
        value: 2
      }),
      point_style: create_enum({
        key: 'filled',
        label: 'Point Style',
        value: 'Solid Circles',
        options: [
          'Circles',
          'Solid Circles'
        ]
      }),
      show_legend: create_bool({
        key: 'show_legend',
        label: 'Show Legend',
        value: true
      }),
      show_grid: create_bool({
        key: 'show_grid',
        label: 'Show Grid',
        value: true
      })
    }
  },
  'stacked-bar-chart'() {
    return {
      colors: create_continuous_colors({
        key: 'colors',
        label: 'Color',
        value: 11
      }),
      show_grid: create_bool({
        key: 'show_grid',
        label: 'Show Grid',
        value: true
      }),
      show_legend: create_bool({
        key: 'show_legend',
        label: 'Show Legend',
        value: true
      })
    }
  },
  'word-cloud'() {
    return {
      colors: create_continuous_colors({
        key: 'colors',
        label: 'Color Spectrum',
        value: 0
      }),
      background: create_single_color_picker({
        key: 'background',
        label: 'Background Color',
        options: [transparent, ...candela_cat_10.colors, black, white],
        value: 13
      }),
      angle_range: create_range_number({
        key: 'angle_range',
        label: 'Angle Range',
        range: [0, 360],
        value: [270, 360],
        step: 1
      }),
      angle_count: create_discrete_number({
        key: 'angles',
        label: 'Number of Angles',
        min: 1,
        max: 32,
        value: 2
      }),
      spiral: create_enum({
        key: 'sprial',
        label: 'Spiral Type',
        value: 'archimedean',
        options: [
          {value: 'archimedean', text: 'Archimedean'},
          {value: 'rectangular', text: 'Rectangular'}
        ]
      })
    }
  }
}
